var _defs, _text, _text2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 156,
    height: 41,
    viewBox: "0 0 156 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0.5,
    cy: 0.5,
    r: 10.57,
    gradientTransform: "matrix(0.081, 0.997, -0.032, 0.003, 0.475, 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#042d5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#194f80"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(58 32)",
    fill: "#030303",
    fontSize: 32,
    fontFamily: "TrebuchetMS, Trebuchet MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -46.5,
    y: 0
  }, "Jhoset"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(134 32)",
    fill: "#194f80",
    fontSize: 32,
    fontFamily: "TrebuchetMS-Bold, Trebuchet MS",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.422,
    y: 0
  }, "NG"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 4,
    rx: 2,
    transform: "translate(4) rotate(90)",
    fill: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.430bfb83ec0daaad0210cd8c2c66457b.svg";
export { ForwardRef as ReactComponent };